import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import theme from "./componentes/NovoTema/theme";
import { resolverRotaPublica } from "./rotasPublicas";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Rotas públicas curto-circuitam o App, que exige sessão para renderizar.
const rotaPublica = resolverRotaPublica(window.location.pathname);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>{rotaPublica || <App />}</ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
